import React, { useEffect, useRef, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import toastError from "../../errors/toastError";

import ScheduleModal from "../ScheduleModal";
import CreateOsModal from "../CreateOsModal";
import LinkExistingOsModal from "../LinkExistingOsModal";
import AiOsSuggestionModal from "../AiOsSuggestionModal";

const TicketOptionsMenu = ({
	ticket,
	schedule,
	transfer,
	resolveSilent = true,
	showOsActions = true,
	menuOpen,
	handleClose,
	anchorEl
}) => {
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const isMounted = useRef(true);
	const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
	const [createOsModalOpen, setCreateOsModalOpen] = useState(false);
	const [linkOsModalOpen, setLinkOsModalOpen] = useState(false);
	const [aiOsModalOpen, setAiOsModalOpen] = useState(false);
	const [aiSuggestion, setAiSuggestion] = useState(null);
	const [contactId, setContactId] = useState(null);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleCloseSilentTicket = async () => {
		try {
			await api.put(`/tickets/close/${ticket.id}`, {silent: true});
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = e => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	const handleOpenScheduleModal = () => {
		handleClose();
		setContactId(ticket.contact.id);
		setScheduleModalOpen(true);
	}

	const handleCloseScheduleModal = () => {
		setScheduleModalOpen(false);
		setContactId(null);
	}

	const handleOpenCreateOsModal = () => {
		handleClose();
		setAiSuggestion(null);
		setCreateOsModalOpen(true);
	}

	const handleCloseCreateOsModal = () => {
		setCreateOsModalOpen(false);
		setAiSuggestion(null);
	}

	const handleOpenLinkOsModal = () => {
		handleClose();
		setLinkOsModalOpen(true);
	}

	const handleOpenAiOsModal = () => {
		handleClose();
		setAiOsModalOpen(true);
	};

	return (
		<>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				{showOsActions && (
					<>
						<MenuItem onClick={handleOpenCreateOsModal}>
							Criar OS
						</MenuItem>
						<MenuItem onClick={handleOpenAiOsModal}>
							Sugerir OS com IA
						</MenuItem>
						<MenuItem onClick={handleOpenLinkOsModal}>
							Vincular a uma OS existente
						</MenuItem>
					</>
				)}
				{schedule && (
					<MenuItem onClick={handleOpenScheduleModal}>
						{i18n.t("ticketOptionsMenu.schedule")}
					</MenuItem>
				)}
				{transfer && (
					<MenuItem onClick={handleOpenTransferModal}>
						{i18n.t("ticketOptionsMenu.transfer")}
					</MenuItem>
				)}
				{resolveSilent && (
					<MenuItem onClick={handleOpenConfirmationModal}>
						{i18n.t("ticketOptionsMenu.resolveSilent")}
					</MenuItem>
				)}
				{/*
				<Can
					role={user.profile}
					perform="ticket-options:resolveSilent"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("ticketOptionsMenu.resolveSilent")}
						</MenuItem>
					)}
				/>
				*/}
			</Menu>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
					ticket.id
				} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
					ticket.contact.name
				}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleCloseSilentTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<TransferTicketModalCustom
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
			/>
			<ScheduleModal
				open={scheduleModalOpen}
				onClose={handleCloseScheduleModal}
				aria-labelledby="form-dialog-title"
				contactId={contactId}
			/>
			<CreateOsModal
				modalOpen={createOsModalOpen}
				onClose={handleCloseCreateOsModal}
				ticket={ticket}
				initialSuggestion={aiSuggestion}
			/>
			<LinkExistingOsModal
				open={linkOsModalOpen}
				onClose={() => setLinkOsModalOpen(false)}
				ticket={ticket}
			/>
			<AiOsSuggestionModal
				open={aiOsModalOpen}
				onClose={() => setAiOsModalOpen(false)}
				ticket={ticket}
				onSuggestionReady={suggestion => {
					setAiSuggestion(suggestion);
					setCreateOsModalOpen(true);
				}}
			/>
		</>
	);
};

export default TicketOptionsMenu;
